import type { Module } from 'vuex'

import type { AttachableIndexState, RootState } from '@/types/store'

const MIN_ZINDEX = 10000

const attachableIndexModule: Module<AttachableIndexState, RootState> = {
  namespaced: true,

  state: {
    /*
     * uuids: { uuid: zIndex }
     */
    uuids: {},
  },

  getters: {
    getMaxIndex: state => Math.max(
      MIN_ZINDEX,
      ...Object.values(state.uuids).filter((v): v is number => typeof v === 'number' && v > 0)
    ),
  },

  actions: {

    open ({ commit, getters }, id) {
      const index = getters.getMaxIndex + 1
      commit('open', { id, index })
      return index
    },

    close ({ commit }, id) {
      commit('close', id)
    },

    destroy ({ commit }, id) {
      commit('destroy', id)
    },

  },

  mutations: {

    open (state, { id, index }) {
      state.uuids[id] = index
    },

    close (state, id) {
      state.uuids[id] = null
    },

    destroy (state, id) {
      delete state.uuids[id]
    },
  },
}

export default attachableIndexModule
